import { Star, MessageCircle } from "lucide-react";
import { FadeUp, SectionHead } from "../Reveal";
import { waLink } from "../../data/site";
import { track } from "../../lib/analytics";

export const SocialProof = () => (
    <section id="avaliacoes" data-testid="social-proof-section" className="bg-paper py-20 sm:py-28">
        <div className="container-x">
            <div className="grid items-center gap-12 lg:grid-cols-2">
                <SectionHead
                    tag="07 — Prova social"
                    title="Quem compra, recomenda."
                    sub="Estamos preparando este espaço para exibir as avaliações reais dos nossos clientes no Google — com nota média, quantidade de avaliações e comentários verificados."
                />
                <FadeUp delay={0.15}>
                    <div
                        data-testid="reviews-placeholder"
                        className="rounded-2xl border border-dashed border-[#D9D9D9] bg-white p-8 sm:p-10"
                    >
                        <div className="flex items-center gap-1.5 text-[#E0E0E0]">
                            {[...Array(5)].map((_, i) => (
                                <Star key={i} size={26} fill="currentColor" strokeWidth={0} />
                            ))}
                        </div>
                        <p className="mt-5 font-display text-lg font-bold text-ink">Avaliações do Google em breve</p>
                        <p className="mt-2 text-sm leading-relaxed text-smoke">
                            Nada de depoimentos inventados: aqui só entram comentários reais de clientes reais.
                            Enquanto isso, a melhor prova é o nosso atendimento.
                        </p>
                        <a
                            href={waLink("Olá! Quero conhecer o trabalho da Imprima Aki e pedir um orçamento.")}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => track("whatsapp_click", { location: "social_proof" })}
                            data-testid="social-proof-cta"
                            className="mt-6 inline-flex items-center gap-2 rounded-full bg-ink px-6 py-3 text-xs font-bold uppercase tracking-wider text-white transition-colors hover:bg-brand"
                        >
                            <MessageCircle size={15} />
                            Falar com a equipe
                        </a>
                    </div>
                </FadeUp>
            </div>
        </div>
    </section>
);
